import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.js';
import type { MetricsResponse, SmsCostResponse } from './types.js';

export const useMetrics = () => {
  const metrics = useQuery({
    queryKey: ['admin-metrics'],
    queryFn: () => api.request<MetricsResponse>('/v1/admin/metrics'),
  });

  const smsCost = useQuery({
    queryKey: ['admin-sms-cost'],
    queryFn: () => api.request<SmsCostResponse>('/v1/admin/billing/sms-cost'),
  });

  return { metrics, smsCost };
};
